/**
 * @generated SignedSource<<7350279a78634f82453b9eea3eb081b3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventOverviewPageLegacyDescriptionFragment$data = {
  readonly description: string | null | undefined;
  readonly host: {
    readonly events: {
      readonly totalCount: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"HostCardFragment">;
  };
  readonly id: string;
  readonly timeline: {
    readonly " $fragmentSpreads": FragmentRefs<"TimelineFragment">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"TagListFragment">;
  readonly " $fragmentType": "EventOverviewPageLegacyDescriptionFragment";
};
export type EventOverviewPageLegacyDescriptionFragment$key = {
  readonly " $data"?: EventOverviewPageLegacyDescriptionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventOverviewPageLegacyDescriptionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventOverviewPageLegacyDescriptionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Timeline",
      "kind": "LinkedField",
      "name": "timeline",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TimelineFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "host",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HostCardFragment"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 0
            }
          ],
          "concreteType": "EventConnection",
          "kind": "LinkedField",
          "name": "events",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": "events(first:0)"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagListFragment"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "16b752a5455da1e8b8bdf30aab621849";

export default node;
